function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#PowerPointDocument_svg__clip0_1818_35560)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.583 4.585a.417.417 0 00-.417.417v2.5c0 .23.187.416.417.416h2.5c.23 0 .417-.186.417-.416a2.917 2.917 0 00-2.917-2.917z",
  fill: "#FF5722"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.584 8.752c-.69 0-1.25-.56-1.25-1.25V5.46a2.91 2.91 0 103.29 3.29h-2.04z",
  fill: "#FF5722"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.51.508a.417.417 0 00-.353-.083L.323 2.925a.417.417 0 00-.323.41v14.167c0 .205.15.38.353.411l10.834 1.667a.417.417 0 00.48-.412V.835a.417.417 0 00-.157-.327z",
  fill: "#FF5722"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.584 17.918H11.25a.417.417 0 010-.833h7.917V2.918H11.25a.417.417 0 010-.833h8.334c.23 0 .416.187.416.417v15c0 .23-.186.416-.416.416z",
  fill: "#FF5722"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.084 15.418H11.25a.417.417 0 110-.833h5.834a.417.417 0 110 .833zM17.084 12.918H11.25a.417.417 0 110-.833h5.834a.417.417 0 110 .833z",
  fill: "#FF5722"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.75 13.752a.417.417 0 01-.417-.417V6.67c0-.23.187-.417.417-.417h1.667c1.15 0 2.083.933 2.083 2.083v.834c0 1.15-.933 2.083-2.083 2.083h-1.25v2.083c0 .23-.187.417-.417.417zm.417-3.333h1.25c.69 0 1.25-.56 1.25-1.25v-.834c0-.69-.56-1.25-1.25-1.25h-1.25v3.334z",
  fill: "#FAFAFA"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "PowerPointDocument_svg__clip0_1818_35560"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgPowerPointDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgPowerPointDocument;